import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Product Tabs
 */
@Component
export class ProductTimetable extends ThemeComponent {
    @Ref dayTimeTriggers!: HTMLButtonElement[];
    @Ref dayTimetableElements!: HTMLDivElement[];
    @Ref dayInPersonFilterTriggers!: HTMLButtonElement[];
    @Ref({required: false}) dayLiveOnlineFilterTriggers!: HTMLButtonElement[];
    @Ref days!: HTMLDivElement[];
    @Ref({required: false}) tabs!: HTMLDivElement[];
    @Ref dayFilterNavigationButton!: HTMLButtonElement[];

    protected activeTab: HTMLDivElement|undefined|null = null;
    protected activeTimetable: HTMLDivElement|undefined|null = null;
    protected activeDay: HTMLDivElement|undefined|null = null;
    protected activeDayFilterButtons: HTMLButtonElement[]|undefined|null = null;
    protected activeInPersonFilterButton: HTMLButtonElement|undefined|null = null;
    protected activeLiveOnlineFilterButton: HTMLButtonElement|undefined|null = null;
    protected dayFilterinView: HTMLButtonElement|undefined|null = null;
    protected activeTimetableTrigger: HTMLButtonElement|undefined|null = null;

    init() {

        if(this.days){
            this.activeDay = this.days.find((day) => day.classList.contains('active-day'));
        }

        if(this.dayInPersonFilterTriggers){
            this.activeInPersonFilterButton = this.dayInPersonFilterTriggers.find(
                (dayTrigger) => dayTrigger.classList.contains('active-day--filter')
            );
        }

        if (this.dayLiveOnlineFilterTriggers){
            this.activeLiveOnlineFilterButton = this.dayLiveOnlineFilterTriggers.find(
                (dayTrigger) => dayTrigger.classList.contains('active-day--filter')
            );

            this.dayFilterinView = this.dayInPersonFilterTriggers[0];
        }

        if (this.dayLiveOnlineFilterTriggers){
            for (const dayFilterTrigger of this.dayLiveOnlineFilterTriggers) {
                this.$listen(dayFilterTrigger, 'click', (event) => {
                    this.onDayFilterClick(event);
                });
            }
        }

        if (this.dayInPersonFilterTriggers){
            for (const dayFilterTrigger of this.dayInPersonFilterTriggers) {
                this.$listen(dayFilterTrigger, 'click', (event) => {
                    this.onDayFilterClick(event);
                });
            }
        }

        this.activeTimetable = this.dayTimetableElements.find(
            (dayTimetable) => dayTimetable.classList.contains('active-timetable')
        );

        this.activeTimetableTrigger = this.dayTimeTriggers.find(
            (dayTimetableTrigger) => dayTimetableTrigger.classList.contains('active-tab--header')
        );

        for (const dayTimetableTrigger of this.dayTimeTriggers) {
            this.$listen(dayTimetableTrigger, 'click', (event) => {
                this.onDayTimetableNavigation(event);
            });
        }

        for (const dayFilterNavigationTemp of this.dayFilterNavigationButton) {
            this.$listen(dayFilterNavigationTemp, 'click', (event) => {
                this.onDayFilterNavigation(event);
            });
        }
    }

    onDayTimetableNavigation(event: Event) {

        const clickedElement = event.currentTarget as HTMLButtonElement;

        const timetableId = clickedElement.dataset.id;

        const timetableElement = this.dayTimetableElements.find(
            (dayTimetable) => dayTimetable.dataset.id === timetableId
        );

        if (!timetableElement) {return;}

        if (this.activeTimetable) {
            this.activeTimetable.classList.remove('active-timetable');
            this.activeTimetable = timetableElement;
        }

        if (this.activeTimetableTrigger) {
            this.activeTimetableTrigger.classList.remove('active-tab--header');
            this.activeTimetableTrigger = clickedElement;
        }

        if (this.activeTimetable){
            const newActiveDay = this.activeTimetable.querySelector('.active-day') as HTMLDivElement;

            if(newActiveDay){
                this.activeDay = newActiveDay;
            }
        }

        clickedElement.classList.add('active-tab--header');

        timetableElement.classList.add('active-timetable');
    }

    onTabClick(event: Event) {
        const clickedElement = event.currentTarget as HTMLButtonElement;

        const tabId = clickedElement.dataset.id;

        const tabElement = this.tabs.find((tab) => tab.dataset.id === tabId);

        if (!tabElement) {return;}

        if (this.activeTab) {
            this.activeTab.classList.remove('active-tab');
            this.activeTab = tabElement;
        }

        tabElement.classList.add('active-tab');
    }

    onDayFilterNavigation(event: Event) {

        const clickedElement = event.currentTarget as HTMLButtonElement;
        const containerId = clickedElement.dataset.id;
        const selector = `.product-timetable__day__filters__buttons[data-id="${containerId}"]`;
        const container = document.querySelector(selector) as HTMLDivElement;

        if (!container) {return;}

        if (!this.dayFilterinView) {return;}

        if (clickedElement.dataset.direction == 'prev'){

            const nodeElement = this.dayFilterinView as Element;
            const prevButton = nodeElement.previousElementSibling as HTMLButtonElement;

            if (!prevButton) {return;}

            const rightAmount = prevButton.offsetLeft - prevButton.clientWidth;

            if (!rightAmount) {return;}

            container.scrollLeft = rightAmount;

            this.dayFilterinView = prevButton;

        } else {
            const nextButton = this.dayFilterinView.nextElementSibling as HTMLButtonElement;

            if (!nextButton) {return;}

            const leftAmount = nextButton.offsetLeft;

            if (!leftAmount) {return;}

            container.scrollLeft = leftAmount;

            this.dayFilterinView = nextButton;
        }

    }

    onDayFilterClick(event: Event) {

        const clickedElement = event.currentTarget as HTMLButtonElement;

        const dayId = clickedElement.dataset.id;

        let tableType = 'inPerson';

        let dayTrigger = this.dayInPersonFilterTriggers.find((day) => day.dataset.id === dayId);

        if (!dayId) {return;}

        if (dayId.includes('liveOnline')) {
            tableType = 'liveOnline';
            dayTrigger = this.dayLiveOnlineFilterTriggers.find((day) => day.dataset.id === dayId);
        }

        const dayElement = this.days.find((day) => day.dataset.id === dayId);

        if (!dayTrigger) {return;}

        if (!dayElement) {return;}

        if (this.activeLiveOnlineFilterButton && tableType == "liveOnline") {
            this.activeLiveOnlineFilterButton.classList.remove('active-day--filter');
            this.activeLiveOnlineFilterButton = dayTrigger;
        }

        if (this.activeInPersonFilterButton && tableType == "inPerson") {
            this.activeInPersonFilterButton.classList.remove('active-day--filter');
            this.activeInPersonFilterButton = dayTrigger;
        }

        if (this.activeDay) {
            this.activeDay.classList.remove('active-day');
            this.activeDay = dayElement;
        }

        dayTrigger.classList.add('active-day--filter');
        dayElement.classList.add('active-day');
    }
}
